import '~/js/modules/section-hero';
import 'slick-carousel';
import GoFetch from '~/js/modules/fetch-wrapper.js';
import '~/js/sections/root/includes/inclusion-slider';
const fetch = new GoFetch();

function addContentToPopup(content) {
  const offerDetailsPopup = document.querySelector('#offer-details-popup');
  const top = '<h4>offer details</h4>';
  const title = `<h3>${content.title}</h3>`;

  offerDetailsPopup.innerHTML = top + title + content.description;
}

fetch.post('/fetchPromotion/?promo_ids=115718', null)
  .then(response => addContentToPopup(response.data.promotions[0].promotion));


// Sliders
const slider1 = $('.js-bbo-slider').slick({
  initialSlide: 20,
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 500,
  prevArrow: '<button aria-label="Previous" class="prev resort-slider-arrow"><i class="icon icon-button-arrow-prev"></i></button>',
  nextArrow: '<button aria-label="Next" class="next resort-slider-arrow"><i class="icon icon-button-arrow-next"></i></button>'
});

const slider2 = $('.js-btc-slider').slick({
  initialSlide: 15,
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 500,
  prevArrow: '<button aria-label="Previous" class="prev resort-slider-arrow"><i class="icon icon-button-arrow-prev"></i></button>',
  nextArrow: '<button aria-label="Next" class="next resort-slider-arrow"><i class="icon icon-button-arrow-next"></i></button>'
});

const slider3 = $('.js-bng-slider').slick({
  initialSlide: 16,
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 500,
  prevArrow: '<button aria-label="Previous" class="prev resort-slider-arrow"><i class="icon icon-button-arrow-prev"></i></button>',
  nextArrow: '<button aria-label="Next" class="next resort-slider-arrow"><i class="icon icon-button-arrow-next"></i></button>'
});

slider1.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
  const nextImg = slick.$slides[nextSlide];
  const srcImg = nextImg.dataset.src;

  nextImg.src = srcImg;
  nextImg.addEventListener('load', () => {
    nextImg.style.opacity = 1;
  });
});

slider2.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
  const nextImg = slick.$slides[nextSlide];
  const srcImg = nextImg.dataset.src;

  nextImg.src = srcImg;
  nextImg.addEventListener('load', () => {
    nextImg.style.opacity = 1;
  });
});

slider3.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
  const nextImg = slick.$slides[nextSlide];
  const srcImg = nextImg.dataset.src;

  nextImg.src = srcImg;
  nextImg.addEventListener('load', () => {
    nextImg.style.opacity = 1;
  });
});

//countdown

/*let countDownDate = new Date("Dec 10, 2022 23:59:59").getTime();
// console.log(countDownDate);

let counter = setInterval(() => {
  // Get Date Now
  let dateNow = new Date().getTime();

  // Find The Date Difference Between Now And Countdown Date
  let dateDiff = countDownDate - dateNow;

  // Get Time Units
  // let days = Math.floor(dateDiff / 1000 / 60 / 60 / 24);
  let days = Math.floor(dateDiff / (1000 * 60 * 60 * 24));
  let hours = Math.floor((dateDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  let minutes = Math.floor((dateDiff % (1000 * 60 * 60)) / (1000 * 60));
  let seconds = Math.floor((dateDiff % (1000 * 60)) / 1000);

  if(days>=0){
    document.querySelector(".days").innerHTML = days < 10 ? `0${days}` : days;
    document.querySelector(".hours").innerHTML = hours < 10 ? `0${hours}` : hours;
    document.querySelector(".minutes").innerHTML = minutes < 10 ? `0${minutes}` : minutes;
    document.querySelector(".seconds").innerHTML = seconds < 10 ? `0${seconds}` : seconds;

  }else{
    document.querySelector(".days").innerHTML =`00`;
    document.querySelector(".hours").innerHTML = `00`;
    document.querySelector(".minutes").innerHTML = `00`;
    document.querySelector(".seconds").innerHTML = `00`;
  }

  if (dateDiff < 0) {
    clearInterval(counter);
  }
}, 1000);*/

// Variable Declaration
// const caption = document.getElementById("caption");
const $carousel = $('#inc-carousel');
const $control = $('.inc-carousel');

// $($carousel).on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
//   var i = (currentSlide ? currentSlide : 0) + 1;
//   $($carousel, '.slick-dots li').removeClass('slick-active');
//   $($carousel, '.slick-dots li:nth-child( ' + i +' )').addClass('slick-active');
// });

// $carousel.on("init", (event, slick, currentSlide) => {
//   // caption.innerHTML = inclusionsData.slides[0].caption;

//   const i = (currentSlide ? currentSlide : 0) + 1;
//   const dotsWrap = document.querySelector(".slick-dots");
//   const dots = Array.from(dotsWrap.querySelectorAll("li"));

//   $statusSliderTop.text(`${i}/${slick.slideCount}`);

//   const srcs = $carousel
//     .find(`div[data-slick-index='0']`)
//     .find(".slider-item-inner picture source");
//   const img = $carousel
//     .find(`div[data-slick-index='0']`)
//     .find(".slider-item-inner picture img");
//   srcs.each(function () {
//     const imgSrc = $(this).attr("data-srcset");
//     $(this).attr("srcset", imgSrc);
//   });
//   img.attr("src", img.attr("data-src"));

//   if (dots.length > 5) {
//     dots.forEach((dot, index) => {
//       if (index <= 2) {
//         dot.classList.add("large");
//       } else if (index === 3) {
//         dot.classList.add("semi");
//       } else if (index === 4) {
//         dot.classList.add("small");
//       } else {
//         dot.classList.add("none");
//       }
//     });
//     instagramDots(dotsWrap, $carousel);
//   }
// });

// $carousel.on("reInit afterChange", (event, slick, currentSlide) => {
//   const i = (currentSlide ? currentSlide : 0) + 1;

//   $statusSliderTop.text(`${i}/${slick.slideCount}`);
// });

// Initialization carousel
$carousel.slick({
  appendArrows: $control,
  mobileFirst: true,
  variableWidth: true,
  centerMode: true,
  arrows: false,
  dots: false,
  infinite: true,
  prevArrow: '<button class="arrow arrow-prev"><i class="icon-button-arrow-prev"></i></button>',
  nextArrow: '<button class="arrow arrow-next"><i class="icon-button-arrow-next"></i></button>',
  responsive: [
    {
      breakpoint: 767,
      settings: {
        arrows: true,
        centerMode: true,
        variableWidth: true
        // dots: false
      }
    },
    {
      breakpoint: 1199,
      settings: {
        arrows: true,
        centerMode: true,
        variableWidth: true
      }
    }
  ]
});

// $carousel.on('init', (event, slick, currentSlide) => {
//   const i = (currentSlide ? currentSlide : 0) + 1;
//   $statusSliderTop.text(`${i}/${slick.slideCount}`);

//   const dotsWrap = document.querySelector(".slick-dots");
//   const dots = Array.from(dotsWrap.querySelectorAll("li"));

//   if (dots.length > 5) {
//     dots.forEach((dot, index) => {
//       if (index <= 2) {
//         dot.classList.add("large");
//       } else if (index === 3) {
//         dot.classList.add("semi");
//       } else if (index === 4) {
//         dot.classList.add("small");
//       } else {
//         dot.classList.add("none");
//       }
//     });
//     instagramDots(dotsWrap, $carousel);
//   }

// });

// var carousel = $('.carousel').slick(settings);

// carousel.on('afterChange', function(event, slick, currentSlide) {
//   var activeDotEl = $(event.target).find('.slick-dots').find('li.slick-active');
//   activeDotEl.get(0).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
// });